import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { ShopContext } from '../../Context/ShopContext';
import cart_icon from '../Assets/cart_icon.png';
import logosvg from '../Assets/logo.svg';

const Navbar = () => {
  const { getTotalCartItems } = useContext(ShopContext);
  const [menuAberto, setMenuAberto] = useState(false);

  const toggleMenu = () => {
    setMenuAberto(!menuAberto);
  };

  return (
    <div className='nav'>
      <Link to='/' className='nav-logo-link'>
        <img src={logosvg} alt="Logo da Clínica" className='nav-logo' />
      </Link>


      <ul className={`nav-menu ${menuAberto ? 'ativo' : ''}`}>
        <li><Link to='/Lista-de-exames' onClick={() => setMenuAberto(false)}>Nossos Exames</Link></li>
        <li><Link to='/todos-medicos' onClick={() => setMenuAberto(false)}>Nossos Médicos e Profissionais</Link></li>
        <li><Link to='/resultados-exames' onClick={() => setMenuAberto(false)}>Resultados</Link></li>
      </ul>

      <div className="nav-acoes">
        <Link to="/cart" className="nav-carrinho-link">
          <img src={cart_icon} alt="Carrinho de agendamentos" className='nav-carrinho-icone' />
          {getTotalCartItems() > 0 && (
            <div className="nav-carrinho-contador">{getTotalCartItems()}</div>
          )}
        </Link>
      </div>
      <div className={`nav-hamburger ${menuAberto ? 'ativo' : ''}`} onClick={toggleMenu}>
        &#9776;
      </div>
    </div>
  );
};

export default Navbar;
